import cloneDeep from 'lodash/cloneDeep';

import environment from '@/modules/perseo-billing/environments/environment';
import { sendMessageToKiosco } from '@/sections/shared/hooks/useKiosco';

import { DEFAULT_DEV_STATE } from '../../environments/dev-state';

// not using the window object directly is safer for SSR
export const clientWindow =
  typeof window === 'undefined'
    ? {
        location: { href: '', reload: () => null },
        localStorage: { clear: () => null },
        newrelic: null,
        document: { location: { origin: '' } },
        addEventListener: () => null,
        removeEventListener: () => null,
        open: () => ({
          focus: () => null
        }),
        scroll: () => null,
        scrollTo: () => null,
        scrollY: () => null,
        innerWidth: 0,
        innerHeight: 0
      }
    : window;

export function redirectToUrl(to: string) {
  sendMessageToKiosco({ type: 'changeLocation', value: to });
  // redirects should only be set in the backend
  clientWindow.location.href = to;
}

export function getPerseoInitialState() {
  if (environment.deployTarget === 'development') return DEFAULT_DEV_STATE;
  if (typeof window === 'undefined' || !window?.perseoData) return {};

  const { switches, tokens } = cloneDeep(window.perseoData);

  try {
    return {
      switches,
      tokens
    };
  } catch (err) {
    return {
      user: null,
      switches,
      tokens: null
    };
  }
}
